<hr *ngIf="!isFirst" />
<div><ng-content></ng-content></div>
